<template>
    <div class="component-page">
        <Navbar :isHome="true" />
        <Navbar />
        <div class="container mt-5">
            <MenuCategory />
        </div>
        <div class="container mt-5">
            <Button>Ver más</Button>
            <Button :disabled="true">Ver más</Button>
        </div>
        <div class="container mt-5">
            <Button variant="secondary">Ir al curso</Button>
            <Button variant="secondary" :disabled="true">Ir al curso</Button>
        </div>
        <div class="container my-5">
            <div class="row">
                <div class="col-12 col-lg-6">
                    <CardFooterHome
                        imageURL="https://i.ibb.co/j4qTQRh/Card-Footer-Home1.png"
                        title="Enlaces"
                        description="Lorem ipsum dolor sit amet, consectetur "
                        buttonText="Ver más"
                    />
                </div>
                <div class="col-12 col-lg-6">
                    <CardFooterHome
                        imageURL="https://i.ibb.co/j4qTQRh/Card-Footer-Home1.png"
                        title="Eventos y Cursos"
                        description="Lorem ipsum dolor sit amet, consectetur "
                        buttonText="Ver más"
                    />
                </div>
            </div>
        </div>
        <div class="my-5">
            <Banner
                imageCoverURL="https://i.ibb.co/ZgJ6KnH/Banner-Image-Cover.png"
                title="Recursos para la facultades de derecho"
                breadcrumb="Estandares / Extra Curricular"
            />
            <Banner
                size="small"
                imageCoverURL="https://i.ibb.co/ZgJ6KnH/Banner-Image-Cover.png"
                title="Curso de especialización"
                subtitle="Casos"
            />
        </div>
        <div class="my-5">
            <Footer />
        </div>
        <div class="container mt-5 pb-5">
            <ListCardCategoryInfo />
        </div>
        <div class="container mt-5 pb-5">
            <div class="row">
                <div class="col-12 col-lg-6">
                    <VideoCategory videoEmbedURL="https://www.youtube.com/embed/DAAg4M4_VBk" />
                </div>
                <div class="col-12 col-lg-6">
                    <VideoCategory videoEmbedURL="https://www.youtube.com/embed/DAAg4M4_VBk" />
                </div>
            </div>
        </div>
        <div class="container mt-5 pb-5">
            <TitleObservatory text="Comentarios a decisiones" />
        </div>
        <div class="container mt-5 pb-5">
            <ListCardObservatory />
        </div>
        <div class="container mt-5 pb-5">
            <div class="row">
                <div class="col-3">
                    <Input placeholder="Input" />
                </div>
                <div class="col-3">
                    <Input placeholder="Input 2" />
                </div>
                <div class="col-3">
                    <Input placeholder="Input 3" />
                </div>
                <div class="col-3">
                    <Input placeholder="Input 4" error="Campo no válido" />
                </div>
            </div>
        </div>
        <div class="container mt-5 pb-5">
            <div class="row">
                <div class="col-3">
                    <TextArea placeholder="TextArea" />
                </div>
                <div class="col-3">
                    <TextArea placeholder="TextArea 2" />
                </div>
                <div class="col-3">
                    <TextArea placeholder="TextArea 3" />
                </div>
                <div class="col-3">
                    <TextArea placeholder="TextArea 4" error="Campo no válido" />
                </div>
            </div>
        </div>
        <div class="container mt-5 pb-5">
            <div class="row">
                <div class="col-3">
                    <Checkbox id="chk-1" text="Aceptar Acuerdo 01" />
                </div>
                <div class="col-3">
                    <Checkbox id="chk-2" text="Aceptar Acuerdo 02" />
                </div>
                <div class="col-3">
                    <Checkbox id="chk-3" text="Aceptar Acuerdo 03" :disabled="true" />
                </div>
                <div class="col-3">
                    <Checkbox id="chk-4" text="Aceptar Acuerdo 04" />
                </div>
            </div>
        </div>
        <div class="container mt-5 pb-5">
            <div class="col-6">
                <FormContact />
            </div>
        </div>
        <div class="mt-5 pb-5">
            <BannerContact
                imageCoverURL="https://i.ibb.co/Y7JK3jM/Contact-Banner-Img.png"
                title="Contáctanos"
            />
        </div>
        <div class="container mt-5 pb-5">
            <div class="row">
                <div class="col-6">
                    <CardMember
                        imageURL="https://i.ibb.co/N33ckV4/Card-Member-Icon.png"
                        title="Lorem ipsum"
                        description="Lorem ipsum dolor sit amet, consectetur adipiscing elit,"
                    />
                </div>
                <div class="col-6">
                    <CardMember
                        imageURL="https://i.ibb.co/N33ckV4/Card-Member-Icon.png"
                        title="Lorem ipsum"
                        description="Lorem ipsum dolor sit amet, consectetur adipiscing elit,"
                    />
                </div>
            </div>
        </div>
        <div class="container mt-5 pb-5">
            <ListCardPersonInfo />
        </div>
        <div class="container mt-5 pb-5">
            <ListCardResource />
        </div>
        <div class="container mt-5 pb-5">
            <div class="row">
                <div class="col-3">
                    <ButtonDownload text="Descargar" />
                </div>
                <div class="col-3">
                    <ButtonDownload text="Descargar" />
                </div>
                <div class="col-1">
                    <ButtonIcon nameIcon="print" />
                </div>
                <div class="col-1">
                    <ButtonIcon nameIcon="download" />
                </div>
                <div class="col-1">
                    <ButtonIcon nameIcon="twitter" />
                </div>
                <div class="col-1">
                    <ButtonIcon nameIcon="facebook" />
                </div>
                <div class="col-1">
                    <ButtonIcon nameIcon="linkedin" />
                </div>
                <div class="col-1">
                    <ButtonIcon nameIcon="twitter" />
                </div>
            </div>
        </div>
        <div class="container mt-5 pb-5">
            <ButtonsDocument />
        </div>
        <div class="container mt-5 pb-5">
            <ControlPagination />
        </div>
        <div class="container mt-5 pb-5">
            <div class="row">
                <div class="col-4">
                    <FormDocument />
                </div>
            </div>
        </div>
        <div class="container mt-5 p-5 mb-5" style="background: white;">
            <TextDocument textType="title" textAlign="left">Justicia para niña(o)s con discapacidad</TextDocument>
            <TextDocument textType="autor">Renato Constantino</TextDocument>
            <TextDocument textType="place">Pontificia Universidad Católica del Perú</TextDocument>
            <TextDocument textType="time">Abr 10 - 10min lectura</TextDocument>
            <TextDocument textType="subtitle">I. Ficha técnica del caso</TextDocument>
            <TextDocument textType="normalMediumBlue">Áreas del derecho:</TextDocument>
            <TextDocument
                textType="normalRegular"
            >Derecho constitucional, derechos humanos y derecho procesal.</TextDocument>
            <TextDocument textType="normalMediumBlue">Áreas del derecho:</TextDocument>
            <TextDocument
                textType="normalRegular"
            >Derecho constitucional, derechos humanos y derecho procesal.</TextDocument>
            <TextDocument
                textType="normalMediumBlue"
            >Instituciones de ética y responsabilidad profesional:</TextDocument>
            <TextDocument
                textType="normalRegular"
            >Relación con el cliente, conflicto de intereses y deber de veracidad e información.</TextDocument>
            <TextDocument textType="subtitle">II. Caso</TextDocument>
            <TextDocument
                textType="normalRegular"
            >Andrea es una abogada que trabaja para la organización no gubernamental "Por los Niños". A partir de ello, ha conseguido un financiamiento para un proyecto que busca cambiar las situaciones de exclusión estructural contra niños y niñas con discapacidad. Uno de los objetivos de dicho proyecto es conseguir un precedente vinculante del Tribunal Constitucional, que sea favorable al acceso a la educación de niños y niñas con discapacidad. Por ello, Andrea ha estado buscando casos relacionados con discriminación a niños y niñas con discapacidad en centros educativos. Hace poco ha podido encontrar una exclusión contra un niño con discapacidad física en Manchay. Él ha sido excluido por la directora del colegio.</TextDocument>
            <TextDocument
                textType="normalRegular"
            >Al momento de entrevistar a la madre del niño con discapacidad, la madre le dice que ella cree que es posible conseguir otro colegio en una parte más baja del cerro o quizá sea mejor recurrir a una autoridad para que obligue al colegio a aceptar la matricula. Andrea le pide reunirse al día siguiente, para poder comentar el caso en la ONG donde trabaja. Luego de reunirse con la directora de la ONG, Andrea llega a la conclusión de que lo mejor es iniciar una acción de amparo.</TextDocument>
            <TextDocument
                textType="normalRegular"
            >Por ello, al día siguiente en la reunión con la madre y el padre del niño, les dice: “Existen algunos caminos que podemos seguir, pero el mejor, para luchar contra este problema, es seguir una acción de amparo, porque lo que hace el colegio vulnera gravemente el derecho a la educación de su hijo, así como su derecho a la igualdad, y el amparo es la vía idónea para defender esos derechos”</TextDocument>
            <TextDocument
                textType="normalRegular"
            >Evalúe la conducta de la abogada Andrea, a la luz de los principios y deberes de responsabilidad profesional regulados en el Código de Ética del Abogado de los Colegios de Abogados del Perú.</TextDocument>
            <TextDocument textType="subtitle">III. Preguntas guía</TextDocument>
            <TextDocument textType="normalMedium">¿Quién es el cliente Andrea?</TextDocument>
            <TextDocument
                textType="normalMedium"
            >¿Qué interés debe defender Andrea, como abogada, en este patrocinio?</TextDocument>
            <TextDocument textType="normalMedium">¿En qué consiste el en cargo de Andrea?</TextDocument>
            <TextDocument textType="normalMedium">¿Existe un conflicto de intereses en este caso?</TextDocument>
            <TextDocument
                textType="normalMedium"
            >¿El interés que debe defender Andrea y el interés para la ONG en la que trabaja son adversos? ¿Por qué?</TextDocument>
            <TextDocument
                textType="normalMedium"
            >¿Qué debe informar Andrea al cliente, en tanto su abogada?</TextDocument>
            <TextDocument
                textType="normalMedium"
            >¿Qué valores y principios del ejercicio profesional están en juego en el caso?</TextDocument>
            <TextDocument
                textType="normalMedium"
            >¿Cuál debiera ser el proceder de Andrea en este caso?</TextDocument>
            <TextDocument
                textType="normalMedium"
            >¿Qué corresponde que Andrea responda a la madre y al padre del niño?</TextDocument>
        </div>
        <div class="pb-5"></div>
    </div>
    <div class="container my-5 pb-5">
        <div class="row">
            <div class="col-12 col-md-4">
                <InputSearch placeholder="Hola mundo sddsd" />
            </div>
        </div>
    </div>
    <div class="container my-5 pb-5"></div>
    <div class="my-5 pb-5">
        <FooterDocument />
    </div>
    <div class="my-5 pb-5"></div>
    <div class="my-5 pb-5">
        <Button :clickBtn="this.openModalUno">Abrir Modal 01</Button>
        <ModalDocument
            :show="modalUno"
            @updateShow="modalUno = $event"
            title="Registro exitoso"
            description="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus vehicula euismod diam."
        />
        <hr />
        <Button :clickBtn="this.openModalDos">Abrir Modal 02</Button>
        <ModalDocument
            :show="modalDos"
            @updateShow="modalDos = $event"
            title="Información enviada con exito"
            description="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus vehicula euismod diam."
            coverImg="https://i.ibb.co/MhzbWmw/Footer-Doc.png"
        />
    </div>
    <div class="my-5 pb-5"></div>
</template>
<script>
import Navbar from './General/Navbar.vue'
import MenuCategory from './Home/MenuCategory.vue'
import CardFooterHome from './Home/CardFooterHome.vue'

import Button from './General/Button.vue'
import Input from './General/Input.vue'
import TextArea from './General/TextArea.vue'
import Checkbox from './General/Checkbox.vue'

import Banner from './General/Banner.vue'
import Footer from './General/Footer.vue'

import ListCardCategoryInfo from './Category/ListCardCategoryInfo.vue'
import VideoCategory from './Category/VideoCategory.vue'

import TitleObservatory from './Observatory/TitleObservatory.vue'
import ListCardObservatory from './Observatory/ListCardObservatory.vue'

import FormContact from './Contact/FormContact.vue'
import BannerContact from './Contact/BannerContact.vue'

import CardMember from './About/CardMember.vue'
import ListCardPersonInfo from './About/ListCardPersonInfo.vue'

import ListCardResource from './Resource/ListCardResource.vue'

import ButtonDownload from './Document/ButtonDownload.vue'
import ButtonIcon from './Document/ButtonIcon.vue'
import ButtonsDocument from './Document/ButtonsDocument.vue'
import ControlPagination from './Document/ControlPagination.vue'
import FormDocument from './Document/FormDocument.vue'
import TextDocument from './Document/TextDocument.vue'

import InputSearch from './General/InputSearch.vue'

import FooterDocument from './Document/FooterDocument.vue'

import ModalDocument from './Document/ModalDocument.vue'

export default {
    components: {
        Navbar, MenuCategory, Button, CardFooterHome, Banner,
        Footer, ListCardCategoryInfo, VideoCategory, TitleObservatory,
        ListCardObservatory, Input, TextArea, Checkbox, FormContact,
        BannerContact, CardMember, ListCardPersonInfo, ListCardResource,
        ButtonDownload, ButtonIcon, ButtonsDocument, ControlPagination,
        FormDocument, TextDocument, InputSearch, FooterDocument, ModalDocument
    },
    data() {
        return {
            modalUno: false,
            modalDos: false
        }
    },
    methods: {
        openModalUno() {
            console.log("Modal 01", this.modalUno)
            this.modalUno = true;
        },
        openModalDos() {
            console.log("Modal 02", this.modalDos)
            this.modalDos = true;
        }
    },
}
</script>
<style scoped>
.component-page {
    background: #bebebe;
}
</style>